import { render, staticRenderFns } from "./cadreceitasdespesas.vue?vue&type=template&id=16f95043"
import script from "./cadreceitasdespesas.vue?vue&type=script&lang=js"
export * from "./cadreceitasdespesas.vue?vue&type=script&lang=js"
import style0 from "./cadreceitasdespesas.vue?vue&type=style&index=0&id=16f95043&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports